define('views/shared/form/input/address_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/address_component.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'form-input',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {
            'blur input': 'handleTextInput'
        },

        initialize: function(options){
            options = options || {};

            this.context = options.context;

            this.field = options.field;

            this.validate_po_box = true;
            this.is_valid = false;
            this.error = false;
            this.error_feedback = this.field.error.empty;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            // if autocomplete is false and we're in chrome
            if (!this.field.autocomplete && window.chrome) {  
                this.field.autocomplete = 'autocomplete-off-' + (new Date()).getTime();
            } 
            
            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            this.render();
            
        },

        getValue: function(){
            return this.$el.find('input').val();
        },

        handleTextInput: function(e){
            var input = this.$el.find('input'),
                pattern_one = /^\d+\s[A-z]+\s[A-z]+/,
                pattern_two = /\d{1,5}\s\w.\s(\b\w*\b\s){1,2}\w*\./,
                pattern = /\bbox(?:\b$|([\s|\-]+)?[0-9]+)|(p[\-\.\s]*o[\-\.\s]*|(post office|post)\s)b(\.|ox|in)?\b|(^p[\.]?(o|b)[\.]?$)/;

            // this.cip_required = cipRequired();

            // console.log('address_component handleTextInput', input.val() == '' || !input.val(), !pattern_one.test(input.val().toLowerCase()) && !pattern_two.test(input.val().toLowerCase()) || isEmail(input.val()), this.cip_required, pattern.test(input.val().toLowerCase()));

            if(input.val() == '' || !input.val()){

                this.error_feedback = this.field.error.empty;
                this.is_valid = false;
                this.showError();

            } else if(!pattern_one.test(input.val().toLowerCase()) && !pattern_two.test(input.val().toLowerCase()) && isEmail(input.val())){

                this.error_feedback = this.field.error.invalid;
                this.is_valid = false;
                this.showError();
                
            // } else if(this.cip_required){
            } else if(this.validate_po_box){

                // Only test for PO Box if CIP is required
                if(pattern.test(input.val().toLowerCase())){

                    this.error_feedback = this.field.error.invalid;
                    this.is_valid = false;
                    this.showError();

                    return false;
                    
                } else {
                
                    this.is_valid = true;
                    this.removeError();
                    
                }

            } else {
                
                this.is_valid = true;
                this.removeError();
                
            }

        },

        showError: function(){
            this.error = true;
            this.$el.find('.js-form-input-feedback').html(this.error_feedback);
        },

        removeError: function(){
            this.error = false;
            this.$el.find('.js-form-input-feedback').html('');
        },

        updateValue: function(val){
            this.$el.find('input').val(val);
            this.handleTextInput();
        },

        removeFieldValidation: function(enum_value){

            if(enums.form_validation.po_box == enum_value){
                this.validate_po_box = false;
            }

        },

        close: function(){}
    });
});

